import { useState } from "react"

import {
  selectAuthFlowLoading,
  selectIsAppleSignInInit,
} from "@/lib/storage/auth-slice"
import { submitAppleSignIn } from "@/lib/storage/auth-thunks"
import { useAppDispatch, useAppSelector } from "@/lib/storage/hooks"
import { toastManager } from "@/lib/toast"
import IconApple from "@/components/icons/apple"
import { Button } from "@/components/ui/button"

export function AppleSignInButton() {
  const init = useAppSelector(selectIsAppleSignInInit)
  const authFlowLoading = useAppSelector(selectAuthFlowLoading)
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState(false)

  async function onClick() {
    setIsLoading(true)
    try {
      const response = await window.AppleID.auth.signIn()

      await dispatch(
        submitAppleSignIn({
          code: response.authorization.code,
          id_token: response.authorization.id_token,
          email: response.user?.email,
          first_name: response.user?.name?.firstName,
          last_name: response.user?.name?.lastName,
        })
      )
    } catch (error) {
      setIsLoading(false)
      console.error("Apple Sign In error:", error)
      toastManager.add({
        type: "error",
        description: "Unable to sign in with Apple",
      })
    }
  }

  return (
    <Button
      variant="outline"
      size="xl"
      circle
      className="size-15"
      aria-label="Continue with Apple"
      onClick={onClick}
      loading={!init || isLoading}
      disabled={authFlowLoading}
    >
      <IconApple size={20} className="-mt-0.5" />
    </Button>
  )
}

export default AppleSignInButton
